import { useEffect } from 'react'

import * as S from './styles'

import { ReactComponent as Success } from '../../../../assets/icons/toast/balao-sucesso.svg'
import { ReactComponent as Error } from '../../../../assets/icons/toast/balao-erro.svg'
import { ReactComponent as Warning } from '../../../../assets/icons/toast/balao-atencao.svg'
import { ReactComponent as CloseIcon } from '../../../../assets/icons/toast/fechar-toast.svg'

export default function ToastItem({
  type,
  text,
  timeout = 10000,
  onClick,
  setToastActive
}) {
  let icon = <Success />
  let statusColor = 'linear-gradient(160deg, var(--toastSuccessPrimary) 0%, var(--toastSuccessSecondary) 100%)'

  if (type === 'error') {
    statusColor = 'linear-gradient(160deg, var(--toastErrorPrimary) 0%, var(--toastErrorSecondary) 100%)'
    icon = <Error />
  }

  if (type === 'warning') {
    statusColor = 'linear-gradient(160deg, var(--toastWarningPrimary) 0%, var(--toastWarningSecondary) 100%)'
    icon = <Warning />
  }

  useEffect(() => {
    const timer = setTimeout(() => { setToastActive(false) }, timeout)

    return () => clearTimeout(timer)
  }, [])

  return (
    <S.Box statusColor={statusColor} className='toastItem'>
      <S.Content>
        <S.FlexContainer>
          <S.Icon>
            {icon}
          </S.Icon>
          <S.Text>{text}</S.Text>
        </S.FlexContainer>

        <S.Close>
          <CloseIcon onClick={onClick} />
        </S.Close>
      </S.Content>
    </S.Box>
  )
}
